import { render, staticRenderFns } from "./contractView.vue?vue&type=template&id=544f6245&scoped=true&"
import script from "./contractView.vue?vue&type=script&lang=js&"
export * from "./contractView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544f6245",
  null
  
)

export default component.exports